import React, { Component } from 'react'
// components
import { OldButton } from 'components/Button'
import FeatureCard, { Tone } from './FeatureCard'
import SquareBackground from 'components/common/SquareBackground'
import CircleBackground from 'components/common/CircleBackground'
// redux
import { compose } from 'redux'
import { connect } from 'react-redux'
import { Push, push } from 'connected-react-router'
// types
import { Classes } from 'jss'
import { ButtonTypes, ComposeType } from 'types/common'
// styles
import injectSheet from 'react-jss'
import cx from 'classnames'
import { sheet } from './sheet'
import aboutImg from './Images/about.jpg'
// utils
import { LayoutBodySections } from 'lib/layoutVariables'
import { StateSignUp } from 'pages/Auth/SignUp/types'

interface Props {
  classes: Classes
  style?: React.CSSProperties
  push?: Push
}

interface SignUpRouteState {
  isCandidate?: boolean
  role?: StateSignUp
}

interface SignUpSection {
  isCandidate: boolean
  role: StateSignUp
}

class Body extends Component<Props> {
  onClick = (path: string, state?: SignUpRouteState) => {
    if (this.props.push) {
      this.props.push({
        pathname: path,
        state
      })
    }
  }

  signUp = (item: SignUpSection) => {
    this.onClick('/sign-up', {
      isCandidate: item.isCandidate,
      role: item.role
    })
  }

  openAbout() {
    this.onClick('/about')
  }

  renderFeatures(sectionData: any) {
    return sectionData.features.map((el: any, idx: number) => (
      <FeatureCard
        key={idx}
        icon={el.icon}
        title={el.name}
        text={el.text}
        tone={sectionData.featureTones[idx % sectionData.featureTones.length] as Tone}
      />
    ))
  }

  render() {
    const { classes } = this.props
    const recruiterSection = LayoutBodySections.recruiters
    const candidateSection = LayoutBodySections.candidates
    const managerSection = LayoutBodySections.managers

    return (
      <>
        <section className={classes.root}>
          <SquareBackground />
          <CircleBackground />

          {/*about section*/}
          <div id="about" className={cx(classes.component, classes.anchor)} key="about">
            <div className={cx(classes.leftBlock, classes.titleBlock)}>
              <h3>About Us</h3>
              <p>
                The Skilent Talent Acquisition tool features all the required functionality in
                compliance with the client's needs. The key benefits of this all-in-one platform
                include:
              </p>
              <ul>
                <li>
                  Quick and easy access to essential information (like job type, applicants'
                  experience, skills, qualifications, location details, work preferences, etc.)
                </li>
                <li> Sophisticated search engine to find matching candidates or suitable jobs</li>
                <li> Data-driven dashboards for all users</li>
                <li>
                  Rock-solid data security in accordance with industry standards, including GDPR
                </li>
                <li> Improved and automated HR processes - scheduling, data management, etc.</li>
                <li>
                  Bounty points that can be redeemed for cash or gift cards (available for
                  recruiters or candidates who bring in new candidates)
                </li>
              </ul>

              <OldButton
                type={ButtonTypes.DefaultRounded}
                label="Learn More"
                onClick={() => this.openAbout()}
              />
            </div>

            <div className={cx(classes.rightBlock, classes.imgAbout)} />
          </div>

          {/*recruiters section*/}
          <div
            id={recruiterSection.anchor}
            className={cx(classes.component, classes.anchor, classes.componentDarker)}
            key={recruiterSection.anchor}
          >
            <div className={cx(classes.leftBlock, classes.titleBlock)}>
              <h3>{recruiterSection.title}</h3>
              <p>
                Streamline your hiring process with our advanced matching technology and
                comprehensive candidate verification.
              </p>
              <OldButton
                type={recruiterSection.typeButton}
                label={recruiterSection.nameButton}
                onClick={() => this.signUp(recruiterSection)}
              />
            </div>

            <div className={cx(classes.rightBlock, classes.featuresBlock)}>
              <div style={{ display: 'grid', gap: 16 }}>
                {this.renderFeatures(recruiterSection)}
              </div>
            </div>
          </div>

          {/*candidates section*/}
          <div
            id={candidateSection.anchor}
            className={cx(classes.component, classes.anchor)}
            key={candidateSection.anchor}
          >
            <div className={cx(classes.leftBlock, classes.featuresBlock)}>
              <div style={{ display: 'grid', gap: 16 }}>
                {this.renderFeatures(candidateSection)}
              </div>
            </div>

            <div className={cx(classes.rightBlock, classes.titleBlock)}>
              <h3>{candidateSection.title}</h3>
              <p>
                Accelerate your career with personalized job matching, skill development insights,
                and direct connections to top employers.
              </p>
              <OldButton
                type={candidateSection.typeButton}
                label={candidateSection.nameButton}
                onClick={() => this.signUp(candidateSection)}
              />
            </div>
          </div>

          {/*managers section*/}
          <div
            id={managerSection.anchor}
            className={cx(classes.component, classes.anchor, classes.componentDarker)}
            key={managerSection.anchor}
          >
            <div className={cx(classes.leftBlock, classes.titleBlock)}>
              <h3>{managerSection.title}</h3>
              <p>
                Join a global community of professionals and connect with leading companies across
                industries and continents.
              </p>
              <OldButton
                type={managerSection.typeButton}
                label={managerSection.nameButton}
                onClick={() => this.signUp(managerSection)}
              />
            </div>

            <div className={cx(classes.rightBlock, classes.featuresBlock)}>
              <div style={{ display: 'grid', gap: 16 }}>{this.renderFeatures(managerSection)}</div>
            </div>
          </div>
        </section>
      </>
    )
  }
}

export default compose<ComposeType<Props>>(
  connect(
    null,
    {
      push
    }
  ),
  injectSheet(sheet(aboutImg))
)(Body)
